import { Error } from '../ErrorHandling';
import { Resource } from '../Resource/Types';

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
}

interface Ready {
  kind: 'ready';
  reportsResource: ReportsResource;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (reportsResource: ReportsResource): Ready => ({
  kind: 'ready',
  reportsResource,
});

export type State = Waiting | Loading | Ready | Error;

export interface Report {
  id: number;
  name: string;
  description: string;
  beta: boolean;
}
export type ReportResource = Resource<Report>;

export interface Reports {
  reports: ReportResource[];
}
export type ReportsResource = Resource<Reports>;
